module.exports = __webpack_public_path__ + "static/media/United_logo 2_blue.938a2f63.png";